import { useState } from 'react';

import { logTrackingEvent } from '@/utils/tracking';

type HandleChangeArgs = {
  accordionIndex: number;
  accordionName?: string;
  itemName?: string;
};

export const useAccordion = () => {
  const [openAccordions, setOpenAccordions] = useState<Record<number, boolean>>({});

  const handleChange = ({ accordionIndex, accordionName = '', itemName = '' }: HandleChangeArgs) => {
    const isOpen = !!openAccordions[accordionIndex];

    logTrackingEvent({
      event: 'accordion_click',
      interaction_type: isOpen ? 'collapse' : 'expand',
      component_name: accordionName,
      component_element: itemName,
    });

    setOpenAccordions((prev) => ({ ...prev, [accordionIndex]: !isOpen }));
  };

  return [openAccordions, handleChange] as const;
};
